<template lang="html">
  <nav>
    <router-link class="artists" :to="{ name: 'home' }">Artists</router-link>
    <router-link
      v-for="link in site.menu"
      :key="link.uid"
      :to="{ name: link.uid }"
      >{{ link.title }}</router-link
    >
  </nav>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["site"])
};
</script>

<style lang="scss" scoped>
@import "../assets/css/defaults.scss";

nav {
  a {
    display: block;
  }
  @media only screen and (max-width: 768px) {
    padding-bottom: $gap * 2;
  }
}
</style>
